import { Badge } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { OVERTIMES_BADGES, OvertimeStatuses, overtimeStatusFromBack } from 'shared/enums/overtime';
import { TOvertimeGetResponse } from 'shared/types/overtime.types';

type TProps = {
  overtime?: TOvertimeGetResponse;
};

type TBadgeTexts = 'success' | 'processing' | 'error' | 'default' | 'warning';

const BadgeData: FC<TProps> = ({ overtime }) => {
  const [text, setText] = useState<OvertimeStatuses>(OvertimeStatuses.LOADED_CPRODUCT);
  const [badgeData, setBadgeData] = useState<TBadgeTexts>('default');

  useEffect(() => {
    if (!overtime) {
      return;
    }
    setBadgeData(OVERTIMES_BADGES[overtime?.status]);
    setText(overtimeStatusFromBack[overtime?.status]);
  }, [overtime]);

  return (
    <span title={overtime?.comment || ''}>
      <Badge status={badgeData} />
      {text}
    </span>
  );
};

export default BadgeData;
